// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

export default function CardHeader() {
  return {
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
        }
      }
    }
  };
}
